import { updateOrAddItemsById, updateOrAddItemById } from '../../helpers'
import { RequestStatus } from '../../helpers/request'
import { PROFILE, QUARTERLY_TAX_RETURNS } from '../action-types'

const INITIAL_STATE = {
    quarterlyTaxReturns: { items: [] },
    quarterlyTaxReturnsFiles: { requestStatus: RequestStatus.IDLE, items: [] },
}

export default (state = INITIAL_STATE, action) => {
    const { type, data } = action

    switch (type) {
        case QUARTERLY_TAX_RETURNS.RECEIVE: {
            const { items: currentItems } = state.quarterlyTaxReturns
            const { items: receivedItems = [] } = data || {}
            const items = updateOrAddItemsById({ currentItems, receivedItems })
            return { ...state, quarterlyTaxReturns: { items } }
        }
        case PROFILE.RECEIVE_PROFILE: {
            const { items: currentItems } = state.quarterlyTaxReturns
            const receivedItems = data?.quarterlyTaxReturns
            const items = updateOrAddItemsById({ currentItems, receivedItems })
            return { ...state, quarterlyTaxReturns: { items } }
        }
        case QUARTERLY_TAX_RETURNS.RECEIVE_FILES: {
            const { items: currentItems } = state.quarterlyTaxReturnsFiles
            const { files: receivedItems } = data
            const files = updateOrAddItemsById({ currentItems, receivedItems })
            return {
                ...state,
                quarterlyTaxReturnsFiles: { requestStatus: RequestStatus.RESOLVED, items: files },
            }
        }
        case QUARTERLY_TAX_RETURNS.REMOVE_FILE: {
            const { id: removeId } = data
            const { items: currentItems } = state.quarterlyTaxReturnsFiles
            const items = currentItems.filter(({ id }) => id !== removeId)
            return { ...state, quarterlyTaxReturnsFiles: { requestStatus: RequestStatus.RESOLVED, items } }
        }
        case QUARTERLY_TAX_RETURNS.DOWNLOAD_RETURN_FILE: {
            const { quarterlyTaxReturnId } = data
            const quarterlyTaxReturn = state.quarterlyTaxReturns.items.find((item) => item.id === quarterlyTaxReturnId)
            const newQuarterlyTaxReturn = { ...quarterlyTaxReturn, hasDownloadedReturn: true }
            return {
                ...state,
                quarterlyTaxReturns: {
                    items: updateOrAddItemById(state.quarterlyTaxReturns.items, newQuarterlyTaxReturn),
                },
            }
        }
        default:
            return state
    }
}
